<template>
  <SVGIcon :path="SECTION_ICONS[`icon${iconId}`]" :size="size" :title="name" />
</template>

<script lang="ts" setup>
import { SECTION_ICONS } from "@/constants/section-icons.constants";

defineProps({
  size: {
    required: false,
    type: Number,
    default: 24
  },
  iconId: {
    type: [Number, String],
    required: true
  },
  name: {
    type: String,
    required: false
  }
});
</script>
